import { PayCategory } from './pay-category';
import { Position } from './position';
import { IRosterCode } from './roster-code';

export class TimesheetBreakdownRule{
  id: number;
  position?: Position;
  rosterCode?: IRosterCode;
  payCategory?: PayCategory;
  breakdownRule?: number;
  weekend?: boolean;
  lock?: boolean;
  active: boolean;
}

